import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import saveCurrentAccount from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";
import updateAccountSettings from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/UpdateAccountSettings";

type HandlerType = Handler<{ isSubscribed: boolean; onSuccess: () => void; onError: (message: string) => void }>;

export const DispatchUpdateAccountSettings: HandlerType = props => {
    props.dispatch(updateAccountSettings({ isSubscribed: props.parameter.isSubscribed }));
};

export const SaveCustomerAccountDetails: HandlerType = props => {
    props.dispatch(saveCurrentAccount({ onSuccess: props.parameter.onSuccess, onError: props.parameter.onError }));
};

export const chain = [DispatchUpdateAccountSettings, SaveCustomerAccountDetails];

const checkoutUpdateUserAccountSubscription = createHandlerChainRunner(chain, "CheckoutUpdateUserAccountSubscription");
export default checkoutUpdateUserAccountSubscription;
